module.exports = __webpack_public_path__ + "static/media/Done.6d810995.svg";